import React, { Fragment, useMemo } from 'react'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { AiResult } from '../../../../../../../models/AiResult'
import { HeaderResultOptionConfig, useDefaultHeaderResultOptions } from './HeaderResultOptions/DefaultHeaderResultOptions'
import { HeaderResultCommentsButton } from './HeaderResultCommentsButton/HeaderResultCommentsButton'
import { HeaderResultOption, HeaderResultOptionsButton } from './HeaderResultOptions/HeaderResultOptionsButton'
import { HeaderResultCopyAllButton } from './HeaderResultCopyAllButton/HeaderResultCopyAllButton'
import { ResultCardHeaderCRMButtons } from './ResultCardHeaderCRMButtons'

export interface ResultCardHeaderButtonsProps {
  className?: string
  aiFeature: AiFeature
  aiResult: AiResult
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
  noResults: boolean
  extraHeaderOptions?: HeaderResultOption[]
  headerResultOptionsConfig?: Partial<HeaderResultOptionConfig>
}

export const DefaultResultCardHeaderButtons: React.FC<ResultCardHeaderButtonsProps> = ({
  className,
  aiFeature,
  aiResult,
  collapsed,
  setCollapsed,
  noResults,
  extraHeaderOptions,
  headerResultOptionsConfig: additionalHeaderResultOptionsConfig,
}) => {
  const headerResultOptionsConfig: HeaderResultOptionConfig = useMemo(
    () => ({
      resultIsCollapsed: collapsed,
      setResultCollapsed: setCollapsed,
      hiddenOptions: [],
      ...additionalHeaderResultOptionsConfig,
    }),
    [collapsed, setCollapsed, additionalHeaderResultOptionsConfig],
  )

  const headerResultOptions = useDefaultHeaderResultOptions(aiFeature, aiResult, headerResultOptionsConfig)

  const extraChildren = (
    <>
      {headerResultOptions.map(({ children }, idx) => (
        <Fragment key={idx}>{children}</Fragment>
      ))}
      {extraHeaderOptions ? extraHeaderOptions.map(({ children }, idx) => <Fragment key={idx}>{children}</Fragment>) : null}
    </>
  )

  return (
    <div className={`d-flex flex-wrap py-2 align-items-center gap-2 ${className ?? ''}`}>
      <HeaderResultCommentsButton aiFeature={aiFeature} aiResult={aiResult} />
      <HeaderResultCopyAllButton aiFeature={aiFeature} aiResult={aiResult} />
      <ResultCardHeaderCRMButtons aiFeature={aiFeature} aiResult={aiResult} />
      <HeaderResultOptionsButton disabled={noResults} resultOptions={[...headerResultOptions, ...(extraHeaderOptions || [])]} />
      {extraChildren}
    </div>
  )
}
